(function() {

    if (!window.videoAddedMuteButtons) window.videoAddedMuteButtons = [];
  
    function waitForVideojs() {
        if (typeof videojs !== "undefined") {
            processVideoPlayers();
        } else {
            const observer = new MutationObserver(mutations => {
                if (mutations[0].addedNodes.length > 0) {
                  const videojsScript = mutations[0].addedNodes.find(n => n.src && n.src.includes('video-js'));
                  if (videojsScript) {
                    observer.disconnect();
                    processVideoPlayers();
                  }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
  
    function processVideoPlayers() {
      document.querySelectorAll('[data-mute-button=true]').forEach(el => {
          const myPlayer = videojs.getPlayer(el.id);
          const autoPlayEvents = ['loadedmetadata', 'durationchange'];
          if (window.videoAddedMuteButtons.includes(myPlayer.id_)) return;
  
          // Add mute button
          const muteButton = document.createElement("button");
          muteButton.classList.add("mute-button");
          muteButton.textContent = "Mute";
          myPlayer.el().appendChild(muteButton);
  
          // Handle mute button click
          muteButton.addEventListener("click", () => {
              // Check for localStorage
              if (localStorage.getItem('autoPlayWithSound') !== '1') {
                  myPlayer.muted(true);
                  playerContainer.removeChild(button);
                  localStorage.setItem('autoPlayWithSound', '1');
              }
              if (localStorage.getItem('autoPlayWithSound') === '1') {
                  myPlayer.muted(false);
                  myPlayer.play();
                  playerContainer.removeChild(button);
              }
          });
  
          myPlayer.on(autoPlayEvents, function(event) {autoplayableListener(event, myPlayer, autoPlayEvents);});
          window.videoAddedMuteButtons.push(myPlayer.id_);
      });
  }
  
  waitForVideojs();
  
    function autoplayableListener (event, myPlayer, autoPlayEvents) {
        if(event.type === 'durationchange' && myPlayer.duration() === Infinity) {
            attemptAutoplay(myPlayer);
            myPlayer.off(autoPlayEvents, autoplayableListener);
        }
        if(event.type === 'loadedmetadata') {
            attemptAutoplay(myPlayer);
            myPlayer.off(autoPlayEvents, autoplayableListener);
        }
    }
  
    function attemptAutoplay(myPlayer) {
        mutedPlay(myPlayer);
    };
  
    function mutedPlay(myPlayer) {
        var button = document.createElement("button");
        var playerContainer = document.getElementById(myPlayer.id_);
  
        // Update the click event listener
        button.addEventListener("click", function() {
            if (localStorage.getItem('autoPlayWithSound') !== '1') {
                myPlayer.muted(true);
                playerContainer.removeChild(button);
                localStorage.setItem('autoPlayWithSound', '1');
            }
            if (localStorage.getItem('autoPlayWithSound') === '1') {
                myPlayer.muted(false);
                myPlayer.play();
                playerContainer.removeChild(button);
            }
        });
        var icon = document.createElement("i");
        button.appendChild(icon).classList.add('icon-volume-up');
        button.classList.add("inner");
        button.setAttribute(
            "style",
            "color: black; background-color:red; width: 100px; height: 100px; opacity: .4;"
        );
  
        // +++ Add the button to the container +++
        playerContainer.appendChild(button);
    }
  })();

/*
function toggleMute() {
    var bcPlayer = videojs.getPlayer('v'); // Get the video player object
    bcPlayer.muted(!bcPlayer.muted()); // Toggle the mute state

    const icon = document.querySelector('.inner');
    icon.style.display = 'none'; // Hides the icon
  }
    */